import React from 'react';
import Link from 'gatsby-link';

const ButtonComponent = ({data, translations}) => {
	let bcData = data.breadcrumbs.map(x => x).filter(x => x.haveStaticUrl);
	let toReturn = bcData[bcData.length - 2];
	return (
		<section className="btn-component">
			<div className="container">
				<div className="row">
					<div className="small-12">
						<div className="btn-container">
							<Link className="btn" to={toReturn.langPath} title="">{translations.btnBack}</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button-component/index.jsx